import { config } from "@src/config";
import { TablePaginationConfig } from "antd/lib/table";
import React from "react";

export const usePagination = (
  total = 0,
  pageSize = config.INITIAL_PAGE_SIZE,
  pageSizeOptions = config.INITIAL_PAGE_SIZE_OPTIONS,
) => {
  const [pageOptions, setPageOptions] = React.useState({
    currentPage: 1,
    pageSize,
  });
  const paginationProps: TablePaginationConfig = {
    total,
    pageSize: pageOptions.pageSize,
    pageSizeOptions,
    onChange(page, pageSize) {
      setPageOptions({
        currentPage: page,
        pageSize,
      });
    },
    showSizeChanger: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  };
  const pagingQuery = {
    limit: pageOptions.pageSize,
    offset: (pageOptions.currentPage - 1) * pageOptions.pageSize,
  };
  const resetPageOptions = () => {
    setPageOptions({
      currentPage: 1,
      pageSize,
    });
  };
  return {
    pageSize: pageOptions.pageSize,
    currentPage: pageOptions.currentPage,
    paginationProps,
    pagingQuery,
    setPageOptions,
    resetPageOptions,
  };
};
